import { USERS_URL } from "../../lib/env";
import { SignInFieldType } from "./Components/SignInForm";
import { getUserData, setAuthentication } from "../../lib/auth";
import { IUser } from "../../types/UserData";
import { gqlRequest } from "../../lib/functions";

type SignInResult = {
  success: boolean;
  error: string | null;
};

export async function signIn(formData: SignInFieldType): Promise<{
  success: boolean;
  message: string | null;
  token?: string;
  user?: IUser | null;
}> {
  const { username, password, remember } = formData;

  const gqlString = `mutation {
    Login(email:"${username}", password:"${password}")
  }`;

  try {
    const response = await gqlRequest<{ Login: string }>({
      query: gqlString,
      endpoint: USERS_URL,
    });

    if (response.errors && response.errors.length > 0) {
      return { success: false, message: response.errors[0].message };
    }

    const token = response.data?.Login;
    if (!token) {
      return { success: false, message: "Invalid credentials" };
    }

    setAuthentication(token, remember);
    const user = await getUserData(token);

    return { success: true, message: null, user };
  } catch (err: unknown) {
    if (typeof err === "object" && err !== null && "errors" in err) {
      return {
        success: false,
        message: (err as any).errors?.[0]?.message ?? "Unknown GraphQL error",
      };
    }
    return {
      success: false,
      message: err instanceof Error ? err.message : "Unknown error occurred",
    };
  }
}
